export default {
  USERS: (state) => state.users,
  // GET_BRANCHES_DATA: (state) => state.branches,
};
